module.exports = __webpack_public_path__ + "img/20220323_194419.d3ee5768.jpg";